import { useQuery } from '@apollo/client';
import React, { useEffect } from 'react';
import MentionBase from './MentionBase';
import { gql } from '../../graphql/generated/gql';
import parseExternalPostId from '../../utils/parseExternalPostId';
import postPath from '../../utils/url/postPath';
import useIsPublicView from '../../utils/useIsPublicView';

const EXTERNAL_POST_MENTION_QUERY = gql(/** @complexity 1 */ `
  query externalPostMention($platform: String!, $externalId: ID!) {
    post: externalPost(platform: $platform, externalId: $externalId) {
      id
      title
    }
  }
`);

interface ExternalPostMentionProps {
  id: string;
  content?: string | null;
  mentionText?: string | null;
  updateCache?: (title: string) => void;
  link?: boolean;
}

const ExternalPostMention = ({
  id,
  content = '',
  mentionText = '',
  updateCache,
  link,
}: ExternalPostMentionProps) => {
  const isPublicView = useIsPublicView();
  const { externalId, platform, anchor } = parseExternalPostId(id) ?? {};
  const { data } = useQuery(EXTERNAL_POST_MENTION_QUERY, {
    variables: {
      // @ts-expect-error
      externalId,
      // @ts-expect-error
      platform,
    },
  });

  const post = data?.post ? data.post : null;

  useEffect(() => {
    if (!isPublicView && post) {
      updateCache?.(post.title);
    }
  }, [updateCache, isPublicView, post]);

  return (
    <MentionBase
      type="external-post"
      to={link && post ? postPath(post, { anchor }) : undefined}
      content={mentionText || post?.title || content || externalId}
    />
  );
};

export default ExternalPostMention;
